import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { ValidatePasswordResetTokenResponse } from '@spilca/accounting_ts/v1/auth_web/auth_service_pb';
import { ValidatePasswordResetTokenResponse as PrivateValidatePasswordResetTokenResponse } from '@spilca/accounting_ts/v1/auth_private/auth_service_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { useNotifications } from '@monorepo/notification';
import { useSearchString } from '@monorepo/helpers';
import { useSiteSettings } from '@monorepo/site-settings';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useValidateRestorePasswordToken = () => {
  const { errorNotification } = useNotifications();
  const { generalRoutes } = useSiteSettings();
  const { resendEmail = '' } = generalRoutes || {};
  const navigate = useNavigate();
  const { getParamByName } = useSearchString();
  const search = getParamByName('secret_key', false);
  const validatePasswordResetToken = useGetRequest(
    REQUEST_TYPES.VALIDATE_PASSWORD_RESET_TOKEN
  );

  const onError = (error: TGRPCPromiseReject) => {
    errorNotification(`${error.status}`);
    navigate(resendEmail);
  };

  const mutation = useMutation<
    | ValidatePasswordResetTokenResponse.AsObject
    | PrivateValidatePasswordResetTokenResponse.AsObject
    | null,
    TGRPCPromiseReject,
    string
  >({ mutationFn: validatePasswordResetToken, retry: false, onError });

  useEffect(() => {
    mutation.mutate(search);
  }, [search]);

  return mutation;
};

export default useValidateRestorePasswordToken;
